<template>
  <div class="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
    <router-link
      :to="{ name: 'offence-cases', params: { id: typeId } }"
      tag="a"
    >
      <div class="report-box zoom-in">
        <div class="box p-5">
          <div class="flex">
            <!-- <component
              :is="offenceIcons[title.trim()]"
              class="report-box__icon text-transpurple"
            ></component> -->
            <div class="ml-auto">
              <Tippy
                v-if="increase"
                tag="div"
                class="report-box__indicator bg-theme-6 cursor-pointer"
                :content="percentage + '% Higher than last month'"
              >
                {{ percentage }}%
                <ChevronUpIcon class="w-4 h-4" />
              </Tippy>
              <Tippy
                v-else
                tag="div"
                class="report-box__indicator bg-theme-9 cursor-pointer"
                :content="percentage + '% Lower than last month'"
              >
                {{ percentage }}%
                <ChevronDownIcon class="w-4 h-4" />
              </Tippy>
            </div>
          </div>
          <div class="text-3xl font-bold leading-8 mt-6">{{ count }}</div>
          <div class="text-md text-gray-600 mt-1">{{ title }}</div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "OffenceCard",
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    percentage: {
      type: Number,
      default: 0
    },
    increase: {
      type: Boolean,
      default: false
    },
    typeId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {
    offenceIcons() {
      return this.$store.state.icons.offenceIcons;
    }
  }
};
</script>
